import { usePropertyStructureType } from '../../../../queries/PropertyFields/TopLevelFields';
import { usePropertyRentalProvideUnitsLater, usePropertyRentalUnitsIncomeRestricted, usePropertyRentalNumberUnits } from '../../../../queries/PropertyFields/RentalUnitsFields';
import { DropDownBox } from '@apply/components';
import { rentalStructureTypes } from './../constants/rentalStructureTypes';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';

export interface StructureAndRentalUnitsProps {
    propertyGuid: string;
    width?: string;
    required?: boolean;
    isReview?: boolean;
}

export const StructureAndRentalUnits: React.FC<StructureAndRentalUnitsProps> = ({
    propertyGuid,
    required,
    width,
    isReview = false,
}) => {
    const label = 'Structure Type';
    const [structureType, set_structureType] = usePropertyStructureType(propertyGuid);
    const [, set_provideRentalUnitsLater] = usePropertyRentalProvideUnitsLater(propertyGuid);
    const [, set_unitsIncomeRestricted] = usePropertyRentalUnitsIncomeRestricted(propertyGuid);
    const [, set_numberRentalUnits] = usePropertyRentalNumberUnits(propertyGuid);

    const onChangeStructuretype = (e: any) => {
        const diffStructure = structureType != e;
        set_structureType(e);
        if (diffStructure) {
            set_provideRentalUnitsLater(undefined);
            set_unitsIncomeRestricted(undefined);
            set_numberRentalUnits(undefined);
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={structureType}
                />
            ) : (
                <div style={{ marginTop: 16 }}>
                    <DropDownBox
                        id={'structureAndRentalUnitsDropDown'}
                        value={structureType}
                        onChange={(value) => onChangeStructuretype(value)}
                        dataSource={rentalStructureTypes}
                        displayExpr={'display'}
                        valueExpr={'display'}
                        width={width}
                        required={required}
                        label={label}
                    />
                </div>
            )}
        </>
    );
};
